/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useState } from "react";
import { gptTestService } from "../../../../../service/gptTestServices";
import { t } from "i18next";

interface Props {
  payload: any;
  batchName: string;
  toggleModal: () => void;
  handlePostSuccess: () => void;
  showToastMessage: (message: string, type: string) => void;
}

const GptTestConfirmModal: React.FC<Props> = ({
  payload,
  batchName,
  toggleModal,
  handlePostSuccess,
  showToastMessage,
}) => {

  const [isPosting, setIsPosting] = useState(false);

  const handlePost = async () => {
    try {

      const response = await gptTestService.saveGptTest(payload);

      if (response?.status) {
        showToastMessage(response?.message, "success");

        toggleModal();
        handlePostSuccess();
      } else {
        showToastMessage(response?.message, "error");
      }

      
    } catch (err: any) {
      console.error(err);
      showToastMessage(
        err?.response?.data?.message,
        "error"
      );
    } finally {
      setIsPosting(false);
    }
  };

  return (
  <div className="fixed inset-0 z-[100] flex items-start justify-center pt-36 p-6 bg-slate-900/80 backdrop-blur-lg animate-in fade-in duration-300">
    <div
      className="absolute inset-0"
      onClick={() => !isPosting && toggleModal()}
    />
    <div className="relative bg-white w-full max-w-md rounded-[3.5rem] shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300">
      <div className="p-8 text-center space-y-6">
        <div className="w-20 h-20 mx-auto rounded-[2rem] flex items-center justify-center shadow-2xl bg-emerald-100 text-emerald-600 shadow-emerald-500/20">
          <span className="material-symbols-outlined text-[30px] font-normal">
            {t('gptTest.icons.check_circle')}
          </span>
        </div>
        <div className="space-y-4">

          <h3 className="text-2xl font-black text-slate-800 tracking-tight">
            {t('gptTest.gptTestDetails.confirmModalTitle')}
          </h3>

          <p className="text-sm font-medium text-slate-500 leading-relaxed px-6">
            {t('gptTest.gptTestDetails.areYouSure')}
            <span className="text-emerald-600 font-black">
              {" "}APPROVE{" "}
            </span>
            {t('gptTest.gptTestDetails.analysisBatch')}
            <span className="font-black text-slate-800 tracking-tight">
              {" "}{batchName}
            </span>?
            <br />
            <span className="text-[11px] font-black mt-6 block uppercase tracking-[0.15em] text-slate-300 italic">
              {t('gptTest.gptTestDetails.confirmModalDesc3')}
            </span>
          </p>
        </div>
        <div className="flex gap-4 pt-6">

          <button
            onClick={toggleModal}
            disabled={isPosting}
            className="flex-1 py-3 bg-slate-100 text-slate-500 rounded-[1.5rem] text-[12px] font-black uppercase tracking-widest hover:bg-slate-200 transition-all active:scale-95 border-none"
          >
            {t('gptTest.gptTestDetails.Return')}
          </button>
          <button
            onClick={() => {
              setIsPosting(true);
              handlePost();
            }}
            disabled={isPosting}
            className="flex-1 py-3 text-white rounded-[1.5rem] text-[12px] font-black uppercase tracking-widest shadow-xl transition-all active:scale-95 bg-[#10B981] shadow-emerald-500/40 border-none flex items-center justify-center gap-2"
          >

            {isPosting ? (
              <>
                <span className="w-5 h-5 border-2 border-white/20 border-t-white rounded-full animate-spin"></span>
                Posting...
              </>
            ) : (
              <>{t('gptTest.gptTestDetails.confirmVerdict')}</>
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
);
};

export default GptTestConfirmModal;